import { Locales } from './schema';

export const getDefaultLocaleByCountry = (country: string): string => {
  switch (country.toLowerCase()) {
    case 'id':
      return Locales.idID;
    case 'kr':
      return Locales.koKR;
    case 'jp':
      return Locales.jaJP;
    default:
      return `en-${country.toUpperCase()}`;
  }
};
